import script from "./GradesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./GradesSection.vue?vue&type=script&setup=true&lang=js"

import "./GradesSection.vue?vue&type=style&index=0&id=b6eaef68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6eaef68"]])

export default __exports__